namespace TabAurous {
    export interface ItemsRegisterRequest extends Serenity.ServiceRequest {
        Items?: TabAurous.Reports.ItemsRegisterRow[];
    }
}
